<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "app"
};
</script>

<style>
.clearfix:after {
  content: "";
  display: table;
  clear: both;
}
a {
  color: #049cfd;
}
#app {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: #eee;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body,
html {
  height: 100%;
  box-sizing: border-box;
}
a {
  text-decoration: none;
}
ul {
  list-style: none;
}
@font-face {
  font-family: "iconfont"; /* project id 1008092 */
  src: url("//at.alicdn.com/t/font_1008092_fgjk7mybex9.eot");
  src: url("//at.alicdn.com/t/font_1008092_fgjk7mybex9.eot?#iefix")
      format("embedded-opentype"),
    url("//at.alicdn.com/t/font_1008092_fgjk7mybex9.woff2") format("woff2"),
    url("//at.alicdn.com/t/font_1008092_fgjk7mybex9.woff") format("woff"),
    url("//at.alicdn.com/t/font_1008092_fgjk7mybex9.ttf") format("truetype"),
    url("//at.alicdn.com/t/font_1008092_fgjk7mybex9.svg#iconfont") format("svg");
}
.fonticon {
  font-family: "iconfont";
  font-style: normal;
}
.amap-info-close {
  display: none !important;
}
</style>
